import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { useViewModel } from "./useViewModel";
import { WelcomeCustomizeOrgDetailsViewModel } from "./WelcomeCustomizeOrgDetailsViewModel";
import { WelcomeCustomizeOrgDetailsFormView } from "./WelcomeCustomizeOrgDetailsFormView";
import { HXProgressBar } from "./HXProgressBar";
export const WelcomeCustomizeOrgDetailsView = observer((props) => {
    const model = useViewModel(WelcomeCustomizeOrgDetailsViewModel, props.container);
    if (!model.organizationId)
        return null;
    return (_jsxs(_Fragment, { children: [model.showProgressBar && _jsx(HXProgressBar, { progress: model.progressBarPercentage }), _jsx(WelcomeCustomizeOrgDetailsFormView, { container: props.container, onSave: () => model.onSave() })] }));
});
